import { render, staticRenderFns } from "./FileDownload.vue?vue&type=template&id=46a56e07&scoped=true&"
import script from "./FileDownload.vue?vue&type=script&lang=js&"
export * from "./FileDownload.vue?vue&type=script&lang=js&"
import style0 from "./FileDownload.vue?vue&type=style&index=0&id=46a56e07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a56e07",
  null
  
)

export default component.exports